import * as types from './actionTypes';
import { api } from './api';

export function showRecurringPayment(policy) {
	return { type: types.PAYMENT__SHOW_RECURRING, policy };
}

export function resetRecurringPayment() {
	return { type: types.PAYMENT__RESET_RECURRING };
}

export function updateRecurringPaymentSource(paymentSource) {
	return { type: types.PAYMENT__UPDATE_RECURRING_PAYMENT_SOURCE, paymentSource };
}

export function reloadWalets() {
	return { type: types.PAYMENT__RELOAD_WALLETS };
}

export function addRecurringPayment(payment) {
	return api({
		types: [types.PAYMENT__ADD_RECURRING_REQUEST, types.PAYMENT__ADD_RECURRING_SUCCESS, types.PAYMENT__ADD_RECURRING_FAILURE],
		uri: '/api/payment/recurring',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(payment)
		},
		payload: { payment }
	});
}

export function removeRecurringPayment(payment) {
	return api({
		types: [types.PAYMENT__REMOVE_RECURRING_REQUEST, types.PAYMENT__REMOVE_RECURRING_SUCCESS, types.PAYMENT__REMOVE_RECURRING_FAILURE],
		uri: '/api/payment/recurring',
		shouldCallAPI: () => true,
		config: {
			method: 'delete',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(payment)
		},
		payload: { payment }
	});
}

export function getRecurringPayment(policyNumber, policyId,walletUserIdentifier) {
	return api({
		types: [types.PAYMENT__GET_RECURRING_REQUEST, types.PAYMENT__GET_RECURRING_SUCCESS, types.PAYMENT__GET_RECURRING_FAILURE],
		uri: `/api/payment/recurring?policyNumber=${policyNumber}&policyId=${policyId}&&walletUserIdentifier=${walletUserIdentifier}`,
		shouldCallAPI: () => true,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json'
			}
		},
		payload: { policyNumber, policyId }
	});
}

export function getBankName(routingNumber) {
	return api({
		types: [types.PAYMENT__GET_BANK_NAME_REQUEST, types.PAYMENT__GET_BANK_NAME_SUCCESS, types.PAYMENT__GET_BANK_NAME_FAILURE],
		uri: `/api/payment/bankname/${routingNumber}`,
		shouldCallAPI: () => true,
		sendJwtBearer: false,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			}
		},
		payload: { routingNumber }
	});
}

export function submitPayment(policies, sources) {
	const body = {
		policies,
		sources
	};

	return api({
		types: [types.PAYMENT__SUBMIT_REQUEST, types.PAYMENT__SUBMIT_SUCCESS, types.PAYMENT__SUBMIT_FAILURE],
		uri: '/api/payment',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body)
		},
		payload: body
	});
}

export function submitOnetimePayment(policies, sources) {
	return api({
		types: [types.PAYMENT__SUBMIT_ONETIME_REQUEST, types.PAYMENT__SUBMIT_ONETIME_SUCCESS, types.PAYMENT__SUBMIT_ONETIME_FAILURE],
		uri: '/api/payment/onetime',
		shouldCallAPI: () => true,
		sendJwtBearer: false,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({ policies, sources })
		},
		payload: { policies, sources }
	});
}

export function getPaymentSettings() {
	return api({
		types: [types.PAYMENT__GET_SETTINGS_REQUEST, types.PAYMENT__GET_SETTINGS_SUCCESS, types.PAYMENT__GET_SETTINGS_FAILURE],
		uri: '/api/payment/settings',
		shouldCallAPI: () => true,
		sendJwtBearer: false,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json'
			}
		}
	});
}

export function getPaymentAuth(policyNumber, emailAddress, userId) {
	var uri = '/api/payment/auth';
	if (policyNumber) uri += `?policyNumber=${policyNumber}`;
	else if (emailAddress) uri += `?emailAddress=${emailAddress}`;
	else if (userId) uri += `?userId=${userId}`;

	return api({
		types: [types.PAYMENT__GET_AUTH_REQUEST, types.PAYMENT__GET_AUTH_SUCCESS, types.PAYMENT__GET_AUTH_FAILURE],
		uri: uri,
		shouldCallAPI: () => true,
		sendJwtBearer: false,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json'
			}
		}
	});
}

export function getPaymentWallets(policyNumbers) {
	return api({
		types: [types.PAYMENT__GET_WALLETS_REQUEST, types.PAYMENT__GET_WALLETS_SUCCESS, types.PAYMENT__GET_WALLETS_FAILURE],
		uri: '/api/payment/wallets?' + ( policyNumbers.length ? policyNumbers.map((pn, i) => `policyNumbers[${i}]=${pn}`).reduce((acc, cur) => `${acc}&${cur}`) : ''),
		shouldCallAPI: () => true,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json'
			}
		}
	});
}

export function addPaymentWallet(paymentData) {
	return api({
		types: [types.PAYMENT__ADD_WALLET_REQUEST, types.PAYMENT__ADD_WALLET_SUCCESS, types.PAYMENT__ADD_WALLET_FAILURE],
		uri: '/api/payment/wallets',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(paymentData)
		},
		payload: paymentData
	});
}

export function updatePaymentWalletItem(walletId, walletItemId, paymentData) {
	const body = {
		walletId,
		walletItemId,
		...paymentData
	};

	return api({
		types: [types.PAYMENT__UPDATE_WALLET_ITEM_REQUEST, types.PAYMENT__UPDATE_WALLET_ITEM_SUCCESS, types.PAYMENT__UPDATE_WALLET_ITEM_FAILURE],
		uri: `/api/payment/wallets/${walletId}/items/${walletItemId}`,
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body)
		},
		payload: body
	});
}

export function removePaymentWalletItem(walletId, itemId, fundingAccountToken) {
	const body = {
		fundingAccountToken
	};

	return api({
		types: [types.PAYMENT__REMOVE_WALLET_ITEM_REQUEST, types.PAYMENT__REMOVE_WALLET_ITEM_SUCCESS, types.PAYMENT__REMOVE_WALLET_ITEM_FAILURE],
		uri: `/api/payment/wallets/${walletId}/items/${itemId}`,
		shouldCallAPI: () => true,
		config: {
			method: 'delete',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body)
		},
		payload: body
	});
}

export function updatePaymentWallet(walletId, emailAddress) {
	const body = {
		walletId,
		emailAddress
	};

	return api({
		types: [types.PAYMENT__UPDATE_WALLET_REQUEST, types.PAYMENT__UPDATE_WALLET_SUCCESS, types.PAYMENT__UPDATE_WALLET_FAILURE],
		uri: `/api/payment/wallets/${walletId}`,
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body)
		},
		payload: body
	});
}

export function getScheduledPayments(policyNumbers) {
	return api({
		types: [types.PAYMENT__GET_SCHEDULED_PAYMENTS_REQUEST, types.PAYMENT__GET_SCHEDULED_PAYMENTS_SUCCESS, types.PAYMENT__GET_SCHEDULED_PAYMENTS_FAILURE],
		uri: '/api/payment/scheduled?' + policyNumbers.map((pn, i) => `policyNumbers[${i}]=${pn}`).reduce((acc, cur) => `${acc}&${cur}`),
		shouldCallAPI: () => true,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			}
		}
	});
}

export function CalculateConvFeeScheduled(policyNumber, amount, walletItemFundingAccountToken, walletItemKeyIdentifier, accountNumber) {
	const body = {
		policyNumber,
		amount,
		walletItemFundingAccountToken,
		walletItemKeyIdentifier,
		accountNumber
	};

	return api({
		types: [types.PAYMENT__SCHEDULED_CALCULATEFEE_REQUEST, types.PAYMENT__SCHEDULED_CALCULATEFEE_SUCCESS, types.PAYMENT__SCHEDULED_CALCULATEFEE_FAILURE],
		uri: '/api/payment/calculateFeeScheduled',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body)
		},
		payload: { body }
	});
}

export function addScheduledPayment(policyNumber, amount, date, walletItemFundingAccountToken, walletItemId, walletItemKeyIdentifier, accountNumber, feeAmount) {
	date = new Date(date).toISOString().split('T')[0];
	const body = {
		policyNumber,
		amount,
		date,
		walletItemFundingAccountToken,
		walletItemId,
		walletItemKeyIdentifier,
		accountNumber,
		feeAmount
	};

	return api({
		types: [types.PAYMENT__ADD_SCHEDULED_PAYMENT_REQUEST, types.PAYMENT__ADD_SCHEDULED_PAYMENT_SUCCESS, types.PAYMENT__ADD_SCHEDULED_PAYMENT_FAILURE],
		uri: '/api/payment/scheduled',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body)
		},
		payload: { body }
	});
}

export function removeScheduledPayment(referenceId, keyIdentifier, policyNumber, fiservScheduledPaymentId) {
	const body = {
		referenceId,
		keyIdentifier,
		policyNumber,
		fiservScheduledPaymentId
	};
	return api({
		types: [types.PAYMENT__REMOVE_SCHEDULED_PAYMENT_REQUEST, types.PAYMENT__REMOVE_SCHEDULED_PAYMENT_SUCCESS, types.PAYMENT__REMOVE_SCHEDULED_PAYMENT_FAILURE],
		uri: '/api/payment/scheduled',
		shouldCallAPI: () => true,
		config: {
			method: 'delete',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body)
		},
		payload: { body }
	});
}

export function shouldCalculateConvienceFee(date = '') {
	const dateToUse = date === '' ? new Date().toISOString().split('T')[0] : new Date(date).toISOString().split('T')[0];

	return api({
		types: [types.PAYMENT__GET_CALCULATEFEE_REQUEST, types.PAYMENT__GET_CALCULATEFEE_SUCCESS, types.PAYMENT__GET_CALCULATEFEE_FAILURE],
		uri: `/api/payment/shouldCalculateFee/${dateToUse}`,

		shouldCallAPI: () => true,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			}
		}
	});
}


export function shouldCalculateConvienceFeeOneTime() {
	return api({
		types: [types.PAYMENT__GET_CALCULATEFEE_REQUEST, types.PAYMENT__GET_CALCULATEFEE_SUCCESS, types.PAYMENT__GET_CALCULATEFEE_FAILURE],
		uri: '/api/payment/shouldCalculateFeeOneTime',
		shouldCallAPI: () => true,
		sendJwtBearer: false,
		config: {
			method: 'get',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			}
		}
	});
}

export function calculateConvienceFee(policies, sources) {
	//sources[0].type = 'credit'
	const body = {
		policies,
		sources
	};

	return api({
		types: [types.PAYMENT__CALCULATEFEE_REQUEST, types.PAYMENT__CALCULATEFEE_SUCCESS, types.PAYMENT__CALCULATEFEE_FAILURE],
		uri: '/api/payment/calculateFee',
		shouldCallAPI: () => true,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body)
		},
		payload: body
	});
}


export function calculateConvienceFeeOneTime(policies, sources) {
	const body = {
		policies,
		sources
	};

	return api({
		types: [types.PAYMENT__CALCULATEFEE_REQUEST, types.PAYMENT__CALCULATEFEE_SUCCESS, types.PAYMENT__CALCULATEFEE_FAILURE],
		uri: '/api/payment/calculateFeeOneTime',
		shouldCallAPI: () => true,
		sendJwtBearer: false,
		config: {
			method: 'post',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(body)
		},
		payload: body
	});
}